import React, { useEffect, useRef } from "react"
import { Network } from "vis-network"
import '../App.css'
import { useSelector } from 'react-redux'

export default function VisComponent(props) {
    const visJsRefTemp = useRef(null);
    const project = useSelector((state) => state.project)
    const timeLinesRedux = project.timeLines

    const options = {
        interaction: { hover: false },
        manipulation: {
            enabled: false,
            initiallyActive: false,
        },
        physics: {
            enabled: false,
        },
    }
    let nodes = []
    let edges = []
    let nodesRedux
    let edgesRedux

    // STEV MOD
    useEffect(() => {
        let momentStart = 0
        timeLinesRedux.forEach(moment => {
            nodesRedux = moment.nodes;
            edgesRedux = moment.edges;

            let momentSpace = (Math.max(moment.priorityArr1, moment.priorityArr2, moment.priorityArr3) * 100) + 50
            let middle = momentStart + (momentSpace / 2) - 70
            //Definir espacio necesario para el Momento (calcular máximo length de cada prioridad)

            // Recorre los nodos de la linea temporal i
            nodesRedux.forEach(nodeR => {
                let node = {
                    "id": moment.timeLineID + "" + nodeR.id + 1,
                    "label": nodeR.label,
                    "shape": nodeR.shape,
                    "color": nodeR.color,
                    "priority": nodeR.priority,
                    "hidden": nodeR.hidden,
                    "y": nodeR.y,
                }

                if (nodeR.type === "momento") {
                    node.x = middle
                } else if (nodeR.type === "diadaField") {
                    node.hidden = nodeR.hidden
                    node.x = momentStart + nodeR.x
                    node.borderWidth = nodeR.borderWidth
                    node.color = nodeR.color
                    node.widthConstraint = nodeR.widthConstraint
                } else {
                    node.x = momentStart + nodeR.x
                }
                if (!nodeR.borderDashes) {
                    node.hidden = nodeR.hidden
                }
                nodes.push(node)
            })

            edges.push({
                "id": moment.timeLineID + "00",
                "from": moment.timeLineID + "00",
                "to": moment.timeLineID + 1 + "00",
                "arrows": {
                    "to": {
                        "enabled": true,
                        "type": 'triangle'
                    }
                }
            })

            edgesRedux.forEach(edgeR => {
                if (!edgeR.arrows) {
                    edges.push({
                        "id": moment.timeLineID + "" + edgeR.id,
                        "from": moment.timeLineID + "" + edgeR.from + 1,
                        "to": moment.timeLineID + "" + edgeR.to + 1,
                        "width": edgeR.width,
                        "dashes": edgeR.dashes
                    }
                    )
                } else {
                    edges.push({
                        "id": moment.timeLineID + "" + edgeR.id,
                        "from": moment.timeLineID + "" + edgeR.from + 1,
                        "to": moment.timeLineID + "" + edgeR.to + 1,
                        "width": edgeR.width,
                        "arrows": {
                            "to": {
                                "enabled": edgeR.arrows.to.enabled,
                                "type": edgeR.arrows.to.type
                            },
                            "dashes": edgeR.dashes
                        }
                    }
                    )
                }

            })

            momentStart += momentSpace
        })

        const network = visJsRefTemp.current && new Network(visJsRefTemp.current, { nodes, edges })

        network.setOptions(options)
        network.setSize('100%', '100%')
    }, [nodes, edges])
    return (
        <div className="overlay">
            <div className="modalCustomizadoLineasTiempo">
                <div className="row justify-content-center align-items-center">
                    <div ref={visJsRefTemp} style={{ height: "85vh" }} />
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <button onClick={props.onClose} className="btn btn-danger mt-3 row justify-content-center align-items-center">Cerrar</button>
                </div>
            </div>
        </div>

    )
}
